import styled from "styled-components";

const StyledAuthorize = styled.section`
    padding: 5%; 
    width: 100%;
    margin: 0;
    height: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`

export default StyledAuthorize;